module.exports = __webpack_public_path__ + "static/media/whitemenu.30dc034e.svg";